import { render, staticRenderFns } from "./FilterStockTransferType.vue?vue&type=template&id=2cbb5090&scoped=true&lang=pug&"
import script from "./FilterStockTransferType.vue?vue&type=script&lang=js&"
export * from "./FilterStockTransferType.vue?vue&type=script&lang=js&"
import style0 from "./FilterStockTransferType.vue?vue&type=style&index=0&id=2cbb5090&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cbb5090",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VDivider,VIcon,VMenu,VSpacer})
